//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var App = angular.module('pphhApp');

	App.service("gisSyncActionController", ["$mdDialog", GisSyncActionController]);
	App.controller("gisSyncDialogController", ["$scope", "$http", "$mdDialog", "$interval",
		"$window", "pphhEnv", GisSyncDialogController]);

	function GisSyncActionController($mdDialog) {
		this.performAction = performAction;


		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body), 
				controller: "gisSyncDialogController",
				templateUrl: "/dma/gisSyncStatus-init"
			});
		}
	}

	function GisSyncDialogController($scope, $http, $mdDialog, $interval, $window, pphhEnv) {

		$scope.status = [];
		$scope.timer = undefined;

		$scope.init = init;
		$scope.requestSync = requestSync;
		$scope.requestSyncStatus = requestSync;
		$scope.closeDialog = closeDialog;
		$scope.exportar = exportar;
		function init() {
			requestSyncStatus();
			$scope.timer = $interval(requestSyncStatus, 30000);
		}

		function requestSyncStatus() {
			$http({
				method: "GET",
				url: "/dma/gisSyncStatus"
			}).then(
				function(response) {
					$scope.status = response.data;
				}
			);

		}

		function requestSync(state) {
			state.inProgress = true;
			var request = {
				method: "POST",
				url: "/dma/gisSync",
				params: {
					dhId: state.id
				}
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			$http(request).then(
				function() {
					state.inProgress = true;
				}
				, function() {
					state.inProgress = false;
				});
		}

		function closeDialog() {
			if ($scope.timer != undefined) {
				$interval.cancel($scope.timer);
			}
			$scope.timer = undefined;
			$mdDialog.hide();

		}
		function exportar(euCode) {
			var url = pphhEnv.global.contextPath + "/dma/gisSyncStatusExport?euCode=" + euCode;
			$window.open(url);
		}

	}

})();